import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import axios from 'axios';
import Button from '@material-ui/core/Button';
import PropTypes from 'prop-types';
import AddStudent from './dialogs/AddStudentDialog';
import { setListStudent } from './actions/studentActions';


/**
 * Function to present the filters and search the pricing plans by the filters
 * @param {*} props
 * @returns
 */
function FilterStudent(props) {
  const { classes } = props;
  const endpoint = 'http://127.0.0.1:8000/api';
  const [statusButtonAdd, setStatusButtonAdd] = useState(false);
  const dispatch = useDispatch();
 
  /**
  * Method to set the list pricing plans
  */
  const getAllStudent = async() => {
    const response = await axios.get(endpoint+'/students');
    dispatch(setListStudent(response.data));
    return response.data;
  };
  /**
  * Methods for the add dialog
  */
  const insertStudent = () => {
    setStatusButtonAdd(true);
  };
  const handleCloseButtonAdd = () => {
    setStatusButtonAdd(false);
  };

  /**
   * Retrieve pricing plan list
   */
  useEffect(() => {
    getAllStudent();  
  }, []);
  return (
    <div style={{textAlign:"left"}}>
          <Button  id="insertStudent" variant="contained" style={{backgroundColor: "#ffdf40", color: "#FFFFFF"}} onClick={insertStudent} >Ingresar Estudiante</Button>
          <AddStudent openStatus={statusButtonAdd} onClosed= {handleCloseButtonAdd}/>
          <br/>  <br/>
        </div>
  );
}

FilterStudent.propTypes = {
  dataStudent: PropTypes.string,
};

FilterStudent.defaultProps = {
  dataStudent: "true"
};

export default FilterStudent
